// // // store.ts
// // import { configureStore, combineReducers } from '@reduxjs/toolkit';
// // import { persistStore, persistReducer } from 'redux-persist';
// // import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
// // import authReducer from '../features/auth/authSlice';

// // const rootReducer = combineReducers({
// //   auth: authReducer,
// //   // ... other reducers
// // });

// // const persistConfig = {
// //   key: 'root',
// //   storage,
// //   // Add the 'auth' slice to the blacklist!
// //   blacklist: ['auth'] 
// // };

// // const persistedReducer = persistReducer(persistConfig, rootReducer);

// // export const store = configureStore({
// //   reducer: persistedReducer,
// //   // ... other middleware configuration
// // });

// // export const persistor = persistStore(store);

// // // ... type exports

// // export type RootState = ReturnType<typeof store.getState>;
// // export type AppDispatch = typeof store.dispatch;
// // store.ts
// import { configureStore, combineReducers } from '@reduxjs/toolkit';
// import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
// import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
// import authReducer from '../features/auth/authSlice';
// import userReducer from '../features/user/userSlice';

// const rootReducer = combineReducers({
//   auth: authReducer,
//   user: userReducer,
//   // ... other reducers
// });

// const persistConfig = {
//   key: 'root',
//   storage,
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         // Ignore the actions from redux-persist
//         ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//       },
//     }),
// });

// export const persistor = persistStore(store);

// // ... type exports
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
// src/app/store.ts

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from '../features/auth/authSlice';
import userReducer from '../features/user/userSlice'; // <-- 1. IMPORT THE NEW REDUCER

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer, // <-- 2. ADD THE USER REDUCER HERE
});

const persistConfig = {
  key: 'root',
  storage,
  // Optional: if you don't want to persist the user profile across sessions,
  // you can blacklist it. This forces a fresh fetch on every page load.
  // blacklist: ['user']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>; // <-- 3. USE rootReducer HERE FOR ACCURATE TYPING
export type AppDispatch = typeof store.dispatch;